<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
          <!-- <Section :section="this.sectionId" /> -->
        </div>
        <h1 v-if="title && titleVisible">{{ title }}</h1>
        <p v-html="content"></p>

        <div v-if="topSections != null && topSections.length != 0">
          <div
            v-for="(item, itemIdx) in topSections"
            :key="'topSection-' + itemIdx"
          >
            <Accordion :isOpenOnLoad="item.openOnLoad">
              <template v-slot:title>{{ item.title }}</template>
              <template v-slot:content
                ><span v-html="item.body"></span
              ></template>
            </Accordion>
          </div>
        </div>

        <Button
          class="govuk-button mt--24"
          text="Get started"
          :url="firstStep"
        ></Button>

        <div v-if="bottomSections != null && bottomSections.length != 0">
          <div
            v-for="(item, itemIdx) in bottomSections"
            :key="'bottomSection-' + itemIdx"
          >
            <Accordion :isOpenOnLoad="item.openOnLoad">
              <template v-slot:title>{{ item.title }}</template>
              <template v-slot:content
                ><span v-html="item.body"></span
              ></template>
            </Accordion>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import { dataService, navigationService } from "../shared";

export default {
  name: "Intro",
  data() {
    return {
      id: "",
      sectionId: null,
      title: "",
      titleVisible: null,
      content: "",
      topSections: null,
      bottomSections: null,
      error: false,
      errorMessage: "All fields are required",
      name: "",
      testMode: null,
      firstStep: "",
    };
  },
  created() {
    this.loadQuestion();
    navigationService.addRoutingPath(this.id)
  },
  methods: {
    loadQuestion() {
      let json = dataService.getQuestions();
      let steps = json.steps;
      let currentStep = dataService.findElement(steps, dataService.parseUrl());
      let stepPosition = steps.indexOf(currentStep);
      let topContentSections = currentStep.content.topContentSections;
      let bottomContentSections = currentStep.content.bottomContentSections;

      this.id = currentStep.responseId;
      this.sectionId = currentStep.sectionId;
      this.title = currentStep.title;
      this.titleVisible = currentStep.titleVisible;
      this.content = currentStep.content.body;
      this.topSections = topContentSections;
      this.bottomSections = bottomContentSections;
      this.name = currentStep.responseId;
      this.errorMessage = currentStep.errorMessage;

      currentStep.responses.forEach((element) => {
        this.firstStep = element.path;
      });

      if (stepPosition === 0) {
        dataService.resetResponses();
        for (let s in steps) {
          let step = steps[s];
          if (step.questions.length !== 0) {
            step.questions.forEach((q) => {
              q.response = [];
            });
          }
        }
      }
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    },
  },
};
</script>